import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const BackIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 5 25.199 15.749">
      <path id="ic_reply_all_24px"
            d="M 7.34965181350708 8.149850845336914 L 7.34965181350708 5 L 0 12.34965133666992 L 7.34965181350708 19.69930458068848 L 7.34965181350708 16.54945373535156 L 3.149850845336914 12.34965133666992 L 7.34965181350708 8.149850845336914 Z M 13.64935302734375 9.199800491333008 L 13.64935302734375 5 L 6.299701690673828 12.34965133666992 L 13.64935302734375 19.69930458068848 L 13.64935302734375 15.39450836181641 C 18.89910507202148 15.39450836181641 22.57392883300781 17.07442855834961 25.19880676269531 20.74925422668457 C 24.14885711669922 15.49950408935547 20.99900436401367 10.24975109100342 13.64935302734375 9.199800491333008 Z"></path>
    </SvgIcon>
  );
};

BackIcon.propTypes = {}

BackIcon.defaultProps = {}

export default BackIcon;